// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.food_claim_status_enum */
var FoodClaimStatusEnum;
(function (FoodClaimStatusEnum) {
    FoodClaimStatusEnum["CLAIMED"] = "CLAIMED";
    FoodClaimStatusEnum["CONTRADICTED"] = "CONTRADICTED";
    FoodClaimStatusEnum["NOT_STATED"] = "NOT_STATED";
})(FoodClaimStatusEnum || (FoodClaimStatusEnum = {}));
;
export default FoodClaimStatusEnum;
/** Zod schema for food_claim_status_enum */
export const foodClaimStatusEnum = z.nativeEnum(FoodClaimStatusEnum);
//# sourceMappingURL=FoodClaimStatusEnum.js.map